 <div *ngFor="let section of sections" class="inm-expandable__container">
      <a *ngIf="!section.subSection && checkValidLink(section.feature)" 
        routerLinkActive="active" class="inm-expandable__title" 
        [routerLink]="section.path" [routerLinkActiveOptions]="{ exact: true }">{{ section.name }}</a>
  </div>
  